<template>
  <aside id="aside">
    <div class="aside-block">
      <div class="style-block">
        <div class="support-block ctx-block" v-if="!isAnonimousForm">
          <a href="/cabinet/support/faq" target="_blank">
            <div class="support-circle ctx-circle">
              <img src="/images/cabinet/green-right.svg" alt="arrow-right" />
            </div>
            <div class="support-text">
              <b>Поддержка</b>
              <span
                >Открытых тикетов
                {{ layout.countOpenTickets ? `: ${layout.countOpenTickets}` : 'нет' }}
              </span>
            </div>
          </a>
        </div>
        <a :href="'tel:' + currentPhone" class="phone">
          <img src="/images/redesignedForm/smartphone.svg" alt="phone" />
          {{ currentPhone }}
        </a>
      </div>
      <div class="style-block">
        <div class="order-tabs" v-if="map">
          <CitySelect />
          <MapComponent />
          <template v-if="!isAnonimousForm">
            <button href="#" class="a-block template bigger-mt" @click="toggleModals('templates')">
              <img src="/images/redesignedForm/templates.svg" alt="template" />
              <span>Шаблоны и черновики</span>
            </button>
            <button
              v-if="!base.isEdit"
              href="#"
              class="a-block template"
              @click="
                toggleModals('favouriteCouriers')
                sendMetriks('choose_courier_map')
              "
            >
              <img src="/images/redesignedForm/choose_courier.svg" alt="courier" />
              <span>Выбрать курьера</span>
            </button>
          </template>
        </div>

        <hr class="line" v-if="map" />

        <div class="start-delivery">
          <template v-if="!isCrmCourierChosen">
            <div
              @click="map = !map"
              @keypress="map = !map"
              class="price"
              :class="{ 'mt-15': !map }"
            >
              <h3>
                Цена доставки
                <i
                  ><font-awesome-icon
                    icon="fa-solid fa-chevron-up"
                    :rotation="!map ? '180' : null"
                  />
                </i>
              </h3>
              <Spinner v-if="isFormFetching" />
              <div v-else class="price-container">
                <LightningIcon v-if="isHighDemand" />
                <h3>{{ totalPrice }} &#8381;</h3>
              </div>
            </div>
            <PriceForm v-if="!map" />
            <div class="price" v-if="base.isAdmin && base.isEdit && courierComission != null">
              <h3>Комиссия</h3>
              <Spinner v-if="isFormFetching" />
              <h3 v-else>{{ courierComission }} &#8381; ({{ comissionPercent }}%)</h3>
            </div>
          </template>
          <div class="buttons-block">
            <button
              class="start"
              :disabled="!isCreateAvailable"
              :class="{ 'button-disabled': !isCreateAvailable }"
              @click="submitOrder()"
            >
              <Spinner v-if="isFormFetching" />
              <div v-else>{{ buttonLabel }}</div>
            </button>
            <button
              v-if="!isAnonimousForm"
              v-tooltip.top-center="{
                content: 'Сохранить в черновик',
                trigger: 'hover click',
              }"
              @click="toggleModals('createNewTemplate')"
              class="save-template"
            >
              <div class="icon-save"></div>
            </button>
          </div>
          <div class="order-privacy" v-if="isAnonimousForm">
            Нажимая "Запустить заказ", я принимаю
            <a target="_blank" href="/soglashenie/">соглашение </a> и
            <a target="_blank" href="/politika_konfidencialinosti/">политику конфиденциальности</a>.
          </div>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

import { GENERAL_STORE } from '@apps/order-form/src/store'
import LightningIcon from '@/components/Icons/LightningIcon.vue'
import Spinner from '@/features/UI/FontAwesomeSpinner.vue'
import MapComponent from './Aside/MapComponent.vue'
import PriceForm from './Aside/PriceForm.vue'
import CitySelect from './Aside/CitySelect.vue'

export default {
  name: 'AsideComponent',
  data: () => ({
    map: true,
  }),
  components: {
    CitySelect,
    MapComponent,
    PriceForm,
    LightningIcon,
    Spinner,
  },
  computed: {
    ...mapState(GENERAL_STORE, [
      'form',
      'layout',
      'user',
      'base',
      'advanceCheque',
      'courierComission',
      'isFormFetching',
      'isHighDemand',
    ]),
    ...mapGetters(GENERAL_STORE, [
      'selectedCity',
      'totalPrice',
      'isAnonimousForm',
      'isCrmCourierChosen',
    ]),
    buttonLabel() {
      if (this.base.isRestart) {
        return 'Повторить заказ'
      }

      if (this.base.isEdit) {
        return 'Сохранить изменения'
      }

      return 'Запустить заказ'
    },
    cityId: {
      get() {
        return this.selectedCity.id
      },
      set(value) {
        this.changeCity(value)
        this.calculatePrice()
      },
    },
    currentPhone() {
      return this.selectedCity.phone
    },
    comissionPercent() {
      if (this.courierComission != null) {
        const percent = (this.courierComission / this.totalPrice) * 100

        return percent.toFixed(1)
      }

      return 0
    },
    isCreateAvailable() {
      if (this.isAnonimousForm) {
        return !this.isFormFetching
      }

      return this.user.isCanCreateOrder && !this.isFormFetching
    },
  },
  methods: {
    ...mapMutations(GENERAL_STORE, ['toggleModals']),
    ...mapActions(GENERAL_STORE, ['changeCity', 'calculatePrice', 'submitOrder', 'sendMetriks']),
  },
}
</script>

<style lang="scss" scoped>
.start {
  width: calc(100% - 45px);

  transition: background-color 0.3s;
}

.button-disabled {
  cursor: default !important;

  background-color: grey !important;
}

.buttons-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.phone {
  display: flex;
  align-items: center;

  padding: 5px 5px 5px 0;

  color: black;

  img {
    width: 20px;
    margin-right: 7px;
  }
}

.save-template {
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 40px;
  height: 40px;
  margin-left: 5px;
  padding: 0 15px;

  color: #fff;

  background-color: grey;
  border: none;
  border-radius: 50%;

  transition: background-color 0.6s ease;

  &:hover {
    background-color: #de3e26;
  }
}

.order-privacy {
  margin-top: 15px;

  font-size: 13px;
  text-align: center;

  a {
    color: #de3e26;
  }
}
</style>
